// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"2219359c","258":"c118fbd0","377":"20e810d9","417":"00a6693d","467":"18c773d8","626":"e5e40771","870":"a6e764a9"}[chunkId] + ".js";
};